export default function auth({ next, to, router, store }) {
  if (process.env.NODE_ENV === "development" && to.query.middleware === "false")
    return next();

  const authUser = store.getters.authUser;
  const loginQuery = { path: "/login", query: { redirect: to.fullPath } };

  if (!authUser) {
    store.dispatch("getAuthUser").then(() => {
      if (!store.getters.authUser) return router.push(loginQuery);
      else next();
    });
  } else {
    next(); // make sure to always call next()!
  }
}
